<script>
/* globals moment axios route */
import { Bar, mixins } from 'vue-chartjs';
import tailwind from '../../../../../tailwind';

const { reactiveData } = mixins;

export default {
  mixins: [reactiveData],
  extends: Bar,
  data() {
    return {
      chartData: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Rapport annuel des commandes',
        },
      },
    };
  },

  created() {
    axios.get(route('api.widgets.show', 'orders-chart')).then(({ data }) => {
      this.chartData = {
        labels: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Aout',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre',
        ],
        datasets: [
          {
            label: moment()
              .subtract(1, 'year')
              .year(),
            backgroundColor: tailwind.colors.gray,
            data: data.lastYear,
          },
          {
            label: moment().year(),
            backgroundColor: tailwind.colors.primary,
            data: data.thisYear,
          },
        ],
      };
    });
  },

  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
